import React from 'react';
import { Button, Col, Image, Row } from '@thd-olt-component-react/core-ui';
import { clickEvents } from '../../utils/analytics';
import { generateImageSource } from '../../utils/generateImageSource';

const JobSeekersPod = () => {
  const stepByStepGuideURL = 'https://cdn-static.findly.com/wp-content/uploads/sites/3285/2025/04/09174311/Path-to-Pro-Network-Profile-Setup-Guide_2025.pdf';
  return (
    <div className="ptp-job-seekers-pod__root">
      <div className="ptp-job-seekers-pod__text-container">
        <h2 className="slm-find-candidate-block__header">Job Seekers</h2>
        <div className="ptp-job-seekers-pod__content">
          <div>
            <div className="ptp-job-seekers-pod__text-top">
              Find your next job opportunity
            </div>
            <p className="p">
              Interested in applying to jobs yourself? You can both post jobs on
              Path to Pro Network and browse or apply to jobs as a job seeker.
            </p>
              To access{' '}
            <span className="ptp-job-seekers-pod__text-bold">
                Path to Pro Network for Job Seekers
            </span>
              , please sign up or log into an existing account below.
          </div>
          <Row>
            <Col xs={6}>
              <Button
                outline
                style={{ fontWeight: 700 }}
                data-testid="worksuite-signup"
                onClick={() => {
                  window.open('https://thehomedepot.worksuite.com/invite/0bf0d5ad9a71490681c3f30c79c7c7fe/');
                  clickEvents.jobSeekersButtons('sign up');
                }}
              >
                Sign Up
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                outline
                style={{ fontWeight: 700 }}
                data-testid="worksuite-login"
                onClick={() => {
                  window.open('https://thehomedepot.worksuite.com/login/');
                  clickEvents.jobSeekersButtons('log in');
                }}
              >
                Log In
              </Button>
            </Col>
          </Row>
          <p className="p">
            Access a <a href={stepByStepGuideURL} onClick={() => clickEvents.homePageResourceLinksClick('step by step guide')} target="_blank" rel="noreferrer"> step-by-step guide</a> to build your jobseeker profile.
          </p>
        </div>
      </div>
      <div className="ptp-job-seekers-pod__image-container">
        <Image
          className="ptp-job-seekers-pod__desktop-image"
          src={generateImageSource('/images/v1/path-to-pro/splash-page-pod-desktop.jpg')}
          alt="welder"
        />
        <Image
          className="ptp-job-seekers-pod__mobile-image"
          src={generateImageSource('/images/v1/path-to-pro/spalsh-page-pod-mobile.jpg')}
          alt="welder"
        />
      </div>
    </div>
  );
};

export default JobSeekersPod;
